import AddDesigner from "../scripts/AddDesigner.vue";
import AlertDesigner from "../scripts/AlertDesigner.vue";
import CallApiDesigner from "../scripts/CallApiDesigner.vue";
import ConditionDesigner from "../scripts/ConditionDesigner.vue";
import ConfirmDesigner from "../scripts/ConfirmDesigner.vue";
import DeleteDataDesigner from "../scripts/DeleteDataDesigner.vue";
import DeleteDesigner from "../scripts/DeleteDesigner.vue";
import DisableDesigner from "../scripts/DisableDesigner.vue";
import EditDesigner from "../scripts/EditDesigner.vue";
import EnableDesigner from "../scripts/EnableDesigner.vue";
import EndDesigner from "../scripts/EndDesigner.vue";
import GetDataDesigner from "../scripts/GetDataDesigner.vue";
import GetLocationDesigner from "../scripts/GetLocationDesigner.vue";
import GoBackDesigner from "../scripts/GoBackDesigner.vue";
import GoHomeDesigner from "../scripts/GoHomeDesigner.vue";
import GoPageDesigner from "../scripts/GoPageDesigner.vue";
import HideDesigner from "../scripts/HideDesigner.vue";
import InsertDataDesigner from "../scripts/InsertDataDesigner.vue";
import LoginDesigner from "../scripts/LoginDesigner.vue";
import LogoffDesigner from "../scripts/LogoffDesigner.vue";
import MessageDesigner from "../scripts/MessageDesigner.vue";
import OpenURLDesigner from "../scripts/OpenURLDesigner.vue";
import RefreshDesigner from "../scripts/RefreshDesigner.vue";
import RunWorkflowDesigner from "../scripts/RunWorkflowDesigner.vue";
import SaveDesigner from "../scripts/SaveDesigner.vue";
import SetModelDesigner from "../scripts/SetModelDesigner.vue";
import ShowDesigner from "../scripts/ShowDesigner.vue";
import UpdateDataDesigner from "../scripts/UpdateDataDesigner.vue";
import ExportDataDesigner from "../scripts/ExportDataDesigner.vue";
import DownloadFileDesigner from "../scripts/DownloadFileDesigner.vue";
import RefreshCurrentDesigner from "../scripts/RefreshCurrentDesigner.vue";

export default { AddDesigner, AlertDesigner, CallApiDesigner, ConditionDesigner, ConfirmDesigner, DeleteDataDesigner, DeleteDesigner, DisableDesigner, EditDesigner, EnableDesigner, EndDesigner, GetDataDesigner, GetLocationDesigner, GoBackDesigner, GoHomeDesigner, GoPageDesigner, HideDesigner, InsertDataDesigner, LoginDesigner, LogoffDesigner, MessageDesigner, OpenURLDesigner, RefreshDesigner, RunWorkflowDesigner, SaveDesigner, SetModelDesigner, ShowDesigner, UpdateDataDesigner, ExportDataDesigner, DownloadFileDesigner, RefreshCurrentDesigner }